import React from 'react'
import './index.css'
import { formatDate } from '../../../../configTools/dateFormat'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import DeleteButton from '../../../../components/panelcontrols/paneltablebuttons/deletebutton'
import PrintButton from '../../../../components/panelcontrols/paneltablebuttons/printbutton'
import Functions from '../functions';
import TableSkeleton from '../../../../components/tableskeleton'

// Search is server-side (see billing/index.jsx) so it covers every record, not just this page.
const Index = ({List,setList,search,onSearch,toast,loading}) => {
  const filterList = List;
  return (
    <div className='user_table_wrapper'>
      <div className='user_table_search'>
        <input value={search || ''} onChange={(e)=>onSearch(e.target.value)}/>
        <div className='user_table_search_icon'>
          <FontAwesomeIcon icon={faSearch}/>
        </div>
      </div>
      <div className='user_table_container'>
        <div className='_table'>
          <div className='_thead'>
            <div className='_tr'>
              <div className='_th' style={{width:"15%"}}>In #</div>
              <div className='_th' style={{width:"25%"}}>Doctor</div>
              <div className='_th' style={{width:"25%"}}>Clinic</div>
              <div className='_th' style={{width:"20%"}}>Due Date</div>
              <div className='_th' style={{width:"15%"}}></div>
            </div>
          </div>
          <div className={'_tbody' + (loading && filterList.length > 0 ? ' nv-rows-loading' : '')}>
            {filterList.length > 0 &&
              filterList.map((item,index)=>{
                return(
                  <div className='_tr' key={index}>
                    <div className='_td' style={{width:"15%"}}>BL{item.id}</div>
                    <div className='_td' style={{width:"25%"}}>{item.doctorname}</div>
                    <div className='_td' style={{width:"25%"}}>{item.clinicname}</div>
                    <div className='_td' style={{width:"20%"}}>{formatDate(item.duedate)}</div>
                    <div className='_td' style={{width:"15%",display:"flex", justifyContent:"space-evenly"}}>
                      <PrintButton Action={()=>{
                        window.open(`/labadminreport/billingdetailed?doctor=${item.doctor}&month=${item.month}&duedate=${String(item.duedate)}&billno=${item.id}`);
                      }}/>
                      <DeleteButton Action={()=>{
                        const confermation = window.confirm('Are you sure you want to delete this bill?');
                        if(!confermation){
                          return;
                        }
                        const toastid = toast.loading("Please wait ...",{ position: toast.POSITION.BOTTOM_CENTER});
                        Functions.Delete(item.id,setList,toast,toastid)
                      }}/>
                    </div>
                  </div>
                )
              })
            }
            {loading && filterList.length <= 0 &&
              <TableSkeleton columns={['15%','25%','25%','20%','15%']} rows={5}/>
            }
            {!loading && filterList.length <= 0 &&
              <div className='table_nodata'>
                <p>No data available</p>
              </div>
            }
          </div>
        </div>
      </div>      
    </div>
  )
}

export default Index
